export var ABTestPopulationSegment;
(function (ABTestPopulationSegment) {
    ABTestPopulationSegment["FIRST"] = "1";
    ABTestPopulationSegment["SECOND"] = "2";
    ABTestPopulationSegment["THIRD"] = "3";
    ABTestPopulationSegment["FOURTH"] = "4";
    ABTestPopulationSegment["FIFTH"] = "5";
})(ABTestPopulationSegment || (ABTestPopulationSegment = {}));
export var ABTestIdentifier;
(function (ABTestIdentifier) {
    ABTestIdentifier["FORMATIVE_FEEDBACKS"] = "formative_feedbacks";
    ABTestIdentifier["INTRODUCTORY_ACTIVITY"] = "introductory_activity";
    ABTestIdentifier["REMEDIATION_LOOP"] = "remediation_loop";
})(ABTestIdentifier || (ABTestIdentifier = {}));
//# sourceMappingURL=ab-test.js.map